import { getRemoteConfig } from '@react-native-firebase/remote-config';
import { log, recordError } from 'app/lib/monitoring';
import { Platform } from 'react-native';

type AllowedConfigTypes = string | number | boolean | null;

export interface PartageClubConfig extends Record<string, AllowedConfigTypes> {
  customer_io_enabled: boolean;
  mixpanel_enabled: boolean;
  apple_auth_enabled: boolean;
  showing_notif_setting_screen_enabled: boolean;
  force_canadian_listings_for_guests_enabled: boolean;
}

const DEFAULT_CONFIG = {
  customer_io_enabled: false,
  mixpanel_enabled: false,
  apple_auth_enabled: false,
  showing_notif_setting_screen_enabled: false,
  force_canadian_listings_for_guests_enabled: true,
};

const config: PartageClubConfig = { ...DEFAULT_CONFIG };

const init = async () => {
  // Native Firebase Remote Config is unavailable on web; keep its documented default there.
  if (Platform.OS === 'web') return;
  try {
    const remoteConfig = getRemoteConfig();

    await remoteConfig.setConfigSettings({
      minimumFetchIntervalMillis: 120000,
    });

    await remoteConfig.setDefaults(DEFAULT_CONFIG);

    const fetchedRemotely = await remoteConfig.fetchAndActivate();

    if (fetchedRemotely) {
      log('Configs were retrieved from the backend and activated.');
    } else {
      log('No configs were fetched from the backend, and the local configs were already activated');
    }
    const parameters = remoteConfig.getAll();

    Object.entries(parameters).forEach(($) => {
      const [key, entry] = $;
      if (key.includes('enabled')) {
        config[key] = entry.asBoolean();
      } else {
        config[key] = entry.asString();
      }
    });
  } catch (e) {
    log(e);
    recordError(e);
  } finally {
    log('CURRENT CONFIG', JSON.stringify(config, null, 2));
  }
};

init().catch(log);

export default config;
